<ng-container *ngIf="hasVotes; else noVotes">
  <p class="po-font-display">{{ coverageLabel }}<span class="po-icon po-icon-info calibration__help"
    [p-tooltip]="help" p-tooltip-position="bottom" p-append-in-body="true"></span>
    <small class="calibration__unit">dos achados receberam voto</small></p>

  <div class="calibration__coverage" role="img" [attr.aria-label]="coverageDetail">
    <span class="calibration__coverage-fill" [style.width.%]="coverageWidth"></span>
  </div>
  <div class="calibration__detail">
    <span>{{ coverageDetail }}</span>
    <po-tag *ngIf="lowCoverage" p-type="warning" p-inverse="true" p-value="Cobertura baixa"
      [p-tooltip]="lowCoverageHelp" p-tooltip-position="bottom" p-append-in-body="true"></po-tag>
  </div>

  <p class="po-font-text-bold calibration__title">Falso positivo por severidade</p>
  <ul class="calibration__bars">
    <li *ngFor="let bar of bySeverity; trackBy: trackByLabel" [title]="bar.votes">
      <span class="calibration__key">{{ bar.label }}</span>
      <span class="calibration__track">
        <span class="calibration__fill" [ngClass]="'calibration__fill--' + bar.modifier"
          [style.width.%]="bar.width"></span>
      </span>
      <span class="calibration__value">{{ bar.value }}</span>
    </li>
  </ul>
  <p class="calibration__note" *ngIf="severityNotOrdering">
    Alta erra tanto quanto Média: a severidade ainda não separa o que corrigir primeiro.
  </p>
</ng-container>

<ng-template #noVotes>
  <p class="po-font-text-small" *ngIf="!loading && !loadError">Nenhum voto nos filtros escolhidos.</p>
  <p class="po-font-text-small" *ngIf="loadError">Não foi possível carregar a calibragem.</p>
</ng-template>

<div class="calibration__footer" *ngIf="canOpenCuration">
  <po-button p-kind="secondary" p-size="small" p-icon="po-icon po-icon-export" p-label="Abrir Painel de Curadoria"
    (p-click)="openCuration()"></po-button>
</div>
